import { render, staticRenderFns } from "./indexForCustomForm.vue?vue&type=template&id=6602b494&scoped=true&"
import script from "./indexForCustomForm.vue?vue&type=script&lang=ts&"
export * from "./indexForCustomForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602b494",
  null
  
)

export default component.exports